<template>
  <div class="nav-box">
    <van-nav-bar style="background-color: rgb(4 109 181) !important;">
        <template #title>
            <span style="color: #fff;">{{ safeTitle }}</span>
        </template>
        <template #left>
            <van-icon v-show="safeIsRetrun" name="arrow-left" size="18px" color="#fff" @click="toReturn" />
        </template>
        <template #right>
            
        </template>
    </van-nav-bar>
  </div>
</template>

<script>
export default {
  name: "HeaderView",
  props:['title','isreturn','index'],
  computed:{
    safeTitle(){
        return this.title || ''
    },
    safeIsRetrun(){
        return this.isreturn || true
    },
    safeIndex(){
        return this.index || -1
    }
  },
  methods:{
    toReturn(){
        this.$router.back();
    }
  }
};

</script>

<style>
</style>
